import { Text, Textarea } from '@chakra-ui/react'
import { memo } from 'react'
import { useFormContext } from 'react-hook-form'

export const ObservacoesForm = memo(() => {
  const {
    register,
    formState: { errors },
  } = useFormContext()

  return (
    <>
      <Text fontWeight="bold" textAlign="center" fontSize="15px">
        Observações para o agendamento
      </Text>
      <Textarea
        placeholder="Solicitação de personalização com urgência para entrega até 10/12."
        size="sm"
        borderColor={errors.observacoes ? 'red.500' : '#378BBF'}
        borderRadius="md"
        _focus={{ borderColor: errors.observacoes ? 'red.500' : '#3182ce', boxShadow: '0 0 0 1px #3182ce' }}
        resize="none"
        {...register('observacoes')}
      />
      {errors.observacoes && (
        <Text color="red.500" fontSize="12px">
          {errors.observacoes.message}
        </Text>
      )}
    </>
  )
})

ObservacoesForm.displayName = 'ObservacoesForm'
